import {atom} from 'recoil';

import {ITaskLocationsDict} from '../../shared/types/taskLocationsDict.types';
import {IPageableDto} from '../../shared/types/pageable.types';
import {getEmptyPage} from '../../shared/helpers/getEmptyPage';

export const taskLocationsDictQueryTrigger = atom<number>({
  key: 'taskLocationsDictQueryTrigger',
  default: 0,
});

export const taskLocationsDictQueryByCodeTrigger = atom<number>({
  key: 'taskLocationsDictQueryByCodeTrigger',
  default: 0,
});

export const taskLocationsState = atom<IPageableDto<ITaskLocationsDict>>({
  key: 'taskLocationsState',
  default: getEmptyPage<ITaskLocationsDict>(),
});

export const currentTaskLocationState = atom<ITaskLocationsDict | null>({
  key: 'currentTaskLocationState',
  default: null,
});

export const currentTaskLocationCodeState = atom<string | null>({
  key: 'currentTaskLocationCodeState',
  default: null,
});

export const taskLocationsMapWithNamesState = atom<Map<string, string>>({
  key: 'taskLocationsMapWithNamesState',
  default: new Map<string, string>(),
});
